// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__39Nb9","popupWrapper":"styles_popupWrapper__e_sx8","popup":"styles_popup__3ZGTP"};